import React from "react";
import { Button } from "react-bootstrap";

import "./themeButton.css";

const ThemeButton = ({ value, className, onClick, type, disabled, id }) => {
  return (
    <div className="theme-btn">
      <Button
        className={`btn button-item ${className}`}
        onClick={onClick}
        type={type}
        disabled={disabled}
        id={id}
      >
        {value}
      </Button>
    </div>
  );
};

export default ThemeButton;
